import { render, staticRenderFns } from "./workTaskDetailList.vue?vue&type=template&id=c8476ffc&scoped=true"
import script from "./workTaskDetailList.vue?vue&type=script&lang=js"
export * from "./workTaskDetailList.vue?vue&type=script&lang=js"
import style0 from "./workTaskDetailList.vue?vue&type=style&index=0&id=c8476ffc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8476ffc",
  null
  
)

export default component.exports